
import React from "react";
import moment from "moment";
import withCandidate from "./withCandidate";

const TemplateBody = ({ candidate }) => {
  const languages = candidate?.languages || [];
  const skills = candidate?.skills || [];
  const work = candidate?.workExperiences || [];
  const educations = candidate?.educations || [];
  const references = candidate?.references || [];
  const interests = candidate?.interests || [];

  const formatRange = (start, end, fmt = "MMM YYYY") => {
    const s = start ? moment(start).format(fmt) : "";
    const e = end ? moment(end).format(fmt) : "Aujourd’hui";
    return s && e ? `${s} — ${e}` : s || e || "";
  };

  const guessPct = (lvl) => {
    //const L = (lvl || "").toUpperCase().trim();
    const L = 15;
    const MAP = { C2: 95, C1: 85, B2: 75, B1: 60, A2: 45, A1: 30 };
    return MAP[L] ?? 50;
  };

  return (
    <>
      <style>{`
        /********************************************
         THEME VARIABLES (toutes variantes)
        ********************************************/
        .template-page {
          --accent: #c53030;
          --ink: #1a1a1a;
          --muted: #6b7280;
          --paper: #ffffff;
          --side: #242426;
          --border: #d1d5db;
          --dash: #e5e7eb;
        }

        .template-page[data-theme="blue-pro"] {
          --accent:#2379B8; --ink:#0f172a; --muted:#6b7280;
          --paper:#ffffff; --side:#1d2b33; --border:#cbd5e1; --dash:#dbeafe;
        }
        .template-page[data-theme="slate"] {
          --accent:#64748b; --ink:#1e293b; --muted:#475569;
          --paper:#ffffff; --side:#2c2f33; --border:#cbd5e1; --dash:#e2e8f0;
        }
        .template-page[data-theme="emerald"] {
          --accent:#10b981; --ink:#064e3b; --muted:#5f6b67;
          --paper:#ffffff; --side:#093d32; --border:#bfe3d6; --dash:#c7eedf;
        }
        .template-page[data-theme="royal"] {
          --accent:#7c3aed; --ink:#1e1b4b; --muted:#6b6b9b;
          --paper:#ffffff; --side:#221833; --border:#ddd6fe; --dash:#e5ddff;
        }
        .template-page[data-theme="bordeaux"] {
          --accent:#b91c1c; --ink:#1f1f1f; --muted:#7a6565;
          --paper:#ffffff; --side:#3b0d0d; --border:#fecaca; --dash:#fbd5d5;
        }
        .template-page[data-theme="noir-or"] {
          --accent:#d4a017; --ink:#e5e5e5; --muted:#cccccc;
          --paper:#1b1b1b; --side:#111111; --border:#333; --dash:#444;
        }
        .template-page[data-theme="bleu-clair"] {
          --accent:#3b82f6; --ink:#1e293b; --muted:#64748b;
          --paper:#ffffff; --side:#0f172a; --border:#bfdbfe; --dash:#dbeafe;
        }
        .template-page[data-theme="orange"] {
          --accent:#f97316; --ink:#1a1a1a; --muted:#6b7280;
          --paper:#ffffff; --side:#2a1b0a; --border:#fdba74; --dash:#ffe1c3;
        }
        .template-page[data-theme="teal"] {
          --accent:#0ea5a4; --ink:#0f172a; --muted:#5b7a85;
          --paper:#ffffff; --side:#0b2f33; --border:#99f6e4; --dash:#c6f7f1;
        }
        .template-page[data-theme="forest"] {
          --accent:#22c55e; --ink:#10231b; --muted:#5f776e;
          --paper:#ffffff; --side:#08251a; --border:#a7f3d0; --dash:#c7f0de;
        }
        .template-page[data-theme="rose"] {
          --accent:#e11d48; --ink:#2b0a13; --muted:#a36a7a;
          --paper:#ffffff; --side:#3b0a16; --border:#fecdd3; --dash:#ffd7df;
        }
        .template-page[data-theme="indigo"] {
          --accent:#4f46e5; --ink:#1e1b4b; --muted:#717ab9;
          --paper:#ffffff; --side:#1b1e3f; --border:#c7d2fe; --dash:#dbe1ff;
        }
        .template-page[data-theme="malibaara"] {
          --accent:#2379B8; --ink:#0f172a; --muted:#6b7280;
          --paper:#ffffff; --side:#16222f; --border:#cbd5e1; --dash:#dbeafe;
        }

        /********************************************
         GLOBAL LAYOUT (scopé, sans style global)
        ********************************************/
        .tpl-redSidebar {
          width: 210mm;
          min-height: 297mm;
          background: var(--paper);
          border: 1px solid var(--border);
          margin: 10px auto;
          display: grid;
          grid-template-columns: 260px 1fr;
          box-shadow: 0 10px 25px rgba(0,0,0,.18);
          font-family: Arial, sans-serif;
        }

        body { background:#222; }

        /* LEFT */
        .left {
          background: var(--side);
          padding: 24px 22px;
          color: #fff;
          position: relative;
        }

        .avatar-box {
          width: 140px;
          height: 140px;
          border-radius: 50%;
          overflow: hidden;
          margin: 0 auto 20px;
          border: 6px solid var(--accent);
        }
        .avatar-box img { width:100%; height:100%; object-fit:cover; display:block; }

        .left .title {
          font-size: 14px;
          font-weight: 900;
          margin-top: 18px;
          margin-bottom: 8px;
          text-transform: uppercase;
        }
        .left .line {
          height: 2px;
          background: var(--accent);
          margin-bottom: 10px;
        }
        .left ul { margin:0; padding-left: 18px; }
        .left li { margin:4px 0; font-size: 13px; }

        /* LANGUES */
        .lang-item { margin-bottom: 14px; }
        .lang-head { display:flex; justify-content:space-between; font-size:13px; }
        .lang-note { opacity: .8; }
        .bar { height: 8px; background:#666; border-radius:999px; overflow:hidden; margin-top:5px; }
        .bar span { display:block; height:100%; background: var(--accent); }

        /* RIGHT */
        .right {
          padding: 32px 36px;
          color: var(--ink);
        }
        .name {
          color: var(--accent);
          font-size: 32px;
          font-weight: 900;
          margin-bottom: 16px;
        }

        .contact {
          display: grid;
          gap: 4px;
          font-size: 14px;
          margin-bottom: 28px;
        }
        .contact div { display:flex; align-items:center; gap:8px; }

        .section + .section { margin-top: 26px; }
        .sec-title {
          font-size: 16px;
          font-weight: 900;
          color: var(--ink);
          margin-bottom: 6px;
        }
        .sec-rule {
          width: 100%;
          height: 2px;
          background: var(--accent);
          margin-bottom: 12px;
        }
        .para { font-size: 14px; line-height: 1.6; }

        .job { margin-bottom: 12px; }
        .job .head { font-weight: 900; }
        .job .sub { font-size: 13px; color: var(--muted); }
        .job ul { margin:6px 0 0 20px; }
        .job li { margin:3px 0; font-size:14px; list-style:disc; }

        .edu-item { margin-bottom:10px; }
      `}</style>

      <div className="tpl-redSidebar">
        
        {/* ================= LEFT ================= */}
        <aside className="left">

          <div className="avatar-box">
            <img 
              crossOrigin="anonymous"
              src={candidate?.profilePictureUrl || "/assets/images/avatar/avatar2.png"} alt="" />
          </div>

          <div className="title">Compétences</div>
          <div className="line"></div>
          <ul>
            {skills.map((s, i) => <li key={i}>{s?.title}</li>)}
          </ul>

          <div className="title">Langue</div>
          <div className="line"></div>
          {languages.map((l, i) => {
            return (
              <div className="lang-item" key={i}>
                <div className="lang-head">
                  <span>{l?.name} - Écrit</span>
                  <span className="lang-note">{l?.writingLevel}</span>
                </div>
                <div className="bar"><span style={{ width: l?.writingLevel * 10 + "%" }} /></div>
                <div className="lang-head" style={{marginTop: "10px"}}>
                  <span>{l?.name} - Parlé</span>
                  <span className="lang-note">{l?.speakingLevel}</span>
                </div>
                <div className="bar"><span style={{ width: l?.speakingLevel * 10 + "%" }} /></div>
              </div>
            );
          })}

        </aside>

        {/* ================= RIGHT ================= */}
        <main className="right">

          <div className="name">
            {candidate?.firstName} {candidate?.lastName}
          </div>

          <div className="contact">
            {candidate?.address && <div>📍 {candidate.address}</div>}
            {candidate?.phoneNumber1 && <div>📞 {candidate.phoneNumber1}</div>}
            {candidate?.email && <div>✉️ {candidate.email}</div>}
          </div>

          {/* PROFIL */}
          <section className="section">
            <div className="sec-title">Profil Professionnel</div>
            <div className="sec-rule"></div>
            <div
              className="para"
              dangerouslySetInnerHTML={{ __html: candidate?.summaryDescription || "" }}
            />
          </section>

          {/* EXP */}
          {!!work.length && (
            <section className="section">
              <div className="sec-title">Parcours Professionnel</div>
              <div className="sec-rule"></div>

              {work.map((job, i) => (
                <div className="job" key={i}>
                  <div className="head">{job?.title}</div>
                  <div className="sub">
                    {job.company && job.company}{" "}
                    {formatRange(job.startDate, job.endDate)}
                  </div>

                  {job.description && (
                    <div className="para">{job.description}</div>
                  )}

                  {Array.isArray(job.achievements) && job.achievements.length > 0 && (
                    <ul>
                      {job.achievements.map((a, k) => <li key={k}>{a}</li>)}
                    </ul>
                  )}
                </div>
              ))}
            </section>
          )}

          {/* FORMATION */}
          {!!educations.length && (
            <section className="section">
              <div className="sec-title">Formation</div>
              <div className="sec-rule"></div>

              {educations.map((edu, i) => (
                <div className="edu-item" key={i}>
                  <div className="head" style={{ fontWeight: 900 }}>
                    {edu?.degree}
                  </div>
                  <div className="sub" style={{ color:"var(--muted)", fontSize:13 }}>
                    {edu?.institution}
                    {edu?.description} {(edu?.startYear || edu?.endYear) &&
                      ` — ${edu.startYear || ""}${edu.endYear ? ` – ${edu.endYear}` : ""}`}
                  </div>
                </div>
              ))}
            </section>
          )}

          {/* References */}
          {!!references.length && (
            <section className="section">
              <div className="sec-title">Références</div>
              <div className="sec-rule"></div>

              {references.map((ref, i) => (
                <div className="job" key={i}>
                  <div className="head">{ref?.fullName}</div>
                  <div className="sub">
                    {ref.title}
                  </div>

                  <div className="para">
                    Tel: {ref.phoneNumber1} / {ref.phoneNumber2} <br />
                    Email: {ref.email}
                  </div>
                </div>
              ))}
            </section>
          )}


        </main>
      </div>
    </>
  );
};

export default withCandidate(TemplateBody, "Modern Deux Colonnes 2");
